import React from "react";
import { Button } from "react-materialize";

export default function MyProfileRightBtnCancel({ data, handleEvents }) {
  return (
    <Button
      className="red"
      id="btn-cancel"
      node="button"
      waves="light"
      onClick={handleEvents}
      style={{
        borderRadius: "8px",
        display: "inline-block",
        margin: "0 auto",
        marginRight: "20px",
      }}
    >
      Cancel
    </Button>
  );
}
